import { useState, useRef, useContext, useEffect } from 'react';
import moment from "moment";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";
import { Link, useNavigate } from 'react-router-dom';
import './Flight.css';
import DefaultData from '../../CompanyData/DefaultData';
import { LandingContext } from '../Profile/LandingContext'; // 2. Import the context 
import useAirportList, { searchAirportList } from './useAirportList';

const FlightSearchPanel = () => {
    const navigate = useNavigate();
    const landingData = useContext(LandingContext);
    const { airports, loading: airportListLoading, error: airportListError } = useAirportList();
    const [departureDate, setDepartureDate] = useState(new Date())
    const [returnDate, setReturnDate] = useState(new Date())
    const [departureResults, setDepartureResults] = useState([]);
    const [arrivalResults, setArrivalResults] = useState([]);
    const [departureSuggestionsOpen, setDepartureSuggestionsOpen] = useState(false);
    const [arrivalSuggestionsOpen, setArrivalSuggestionsOpen] = useState(false);
    const [locationFrom, setLocationFrom] = useState('HYD');
    const [locationTo, setLocationTo] = useState('BOM');
    const [displayFrom, setDisplayFrom] = useState('Hyderabad(HYD), India');
    const [displayTo, setDisplayTo] = useState('Mumbai(BOM), India');
    const [selectedDeparture, setSelectedDeparture] = useState(null);
    const [selectedArrival, setSelectedArrival] = useState(null);
    const [cityFrom, setCityFrom] = useState('Hyderabad');
    const [cityTo, setCityTo] = useState('Mumbai');
    const [from, setFrom] = useState('Hyderabad, India');
    const [to, setTo] = useState('Mumbai, India');
    const [trips, setTrips] = useState([
        { from: "HYD, India", to: "BOM, India", locationFrom: "HYD", locationTo: "BOM", displayFrom: "Hyderabad(HYD)", displayTo: "Mumbai(BOM)", cityFrom: "Hyderabad", cityTo: "Mumbai", departureDate: new Date(), departureResults: [], arrivalResults: [] },
    ]);
    const [adults, setAdults] = useState(1);
    const [kids, setKids] = useState(0);
    const [infants, setInfants] = useState(0);
    const [cabinClass, setCabinClass] = useState("ECONOMY");
    const [preffered, setPreferred] = useState("REGULAR");
    const [isDirect, setIsDirect] = useState(false);
    const [isConnecting, setIsConnecting] = useState(false);
    const [errors, setErrors] = useState({});
    const [isDomestic, setIsDomestic] = useState('DOMESTIC');
    const [journeyType, setJourneyType] = useState("ONEWAY");
    const inputDRef = useRef(null);
    const inputARef = useRef(null);

    useEffect(() => {
        if (airportListLoading || airportListError) return;
        if (departureSuggestionsOpen) {
            setDepartureResults(searchAirportList(airports, displayFrom, selectedArrival?.airportCode));
        }
        if (arrivalSuggestionsOpen) {
            setArrivalResults(searchAirportList(airports, displayTo, selectedDeparture?.airportCode));
        }
    }, [airportListLoading, airportListError, airports, departureSuggestionsOpen, arrivalSuggestionsOpen, displayFrom, displayTo, selectedArrival, selectedDeparture]);

    const validate = () => {
        let temp = {};
        temp.from = from === "" ? false : true;
        temp.to = to === "" ? false : true;
        setErrors(temp);
        return Object.values(temp).every((x) => x === true);
    };
    const handleDepartureAirportSearch = (e) => {
        const value = e.target.value;
        setDisplayFrom(value);
        setFrom("");
        setSelectedDeparture(null);
        setDepartureSuggestionsOpen(true);
        setDepartureResults(airportListLoading ? [] : searchAirportList(airports, value, selectedArrival?.airportCode));
    };
    const handleDepartureAirportClick = (e) => {
        setArrivalResults([]);
        setArrivalSuggestionsOpen(false);
        setDepartureSuggestionsOpen(true);
        setDepartureResults(searchAirportList(airports, "", selectedArrival?.airportCode));
        inputDRef.current?.select();
    };
    const handleDepartureSelect = (data) => {
        if (selectedArrival && selectedArrival.airportCode === data.airportCode) {
            alert("Departure and arrival airports cannot be the same.");
            setSelectedArrival(null);
            setDisplayTo(""); // Clear arrival input
            return;
        } else {
            var DF = data.cityName + "(" + data.airportCode + "), " + data.countryName;
            if (data.countryCode !== "IN") {
                setIsDomestic("INTERNATIONAL")
            }
            setDisplayFrom(DF);
            setLocationFrom(data.airportCode)
            setCityFrom(data.cityName);
            setFrom(data.cityName);
            setSelectedDeparture(data);
            setDepartureResults([]);
            setDepartureSuggestionsOpen(false);
        }
    }
    const handleArrivalAirportSearch = (e) => {
        const value = e.target.value;
        setDisplayTo(value);
        setTo("");
        setSelectedArrival(null);
        setArrivalSuggestionsOpen(true);
        setArrivalResults(airportListLoading ? [] : searchAirportList(airports, value, selectedDeparture?.airportCode));
    };
    const handleArrivalSelect = (data) => {
        if (selectedDeparture && selectedDeparture.airportCode === data.airportCode) {
            alert("Arrival and departure airports cannot be the same.");
            setSelectedDeparture(null);
            setDisplayFrom(""); // Clear departure input
            return;
        }
        else {
            var DF = data.cityName + "(" + data.airportCode + "), " + data.countryName;
            if (data.countryCode !== "IN") {
                setIsDomestic("INTERNATIONAL")
            }
            setDisplayTo(DF);
            setLocationTo(data.airportCode)
            setCityTo(data.cityName);
            setTo(data.cityName);
            setSelectedArrival(data);
            setArrivalResults([]);
            setArrivalSuggestionsOpen(false);
        }
    }
    const handleArrivalAirportClick = (e) => {
        setDepartureResults([]);
        setDepartureSuggestionsOpen(false);
        setArrivalSuggestionsOpen(true);
        setArrivalResults(searchAirportList(airports, "", selectedDeparture?.airportCode));
        inputARef.current?.select();
    };
    const handleClassType = (e) => {
        setCabinClass(e.target.value)
    }
    const handleDirectType = (e) => {
        setIsDirect(e.target.checked)
    }
    const handleConnectingType = (e) => {
        setIsConnecting(e.target.checked)
    }
    const handlePrefferedType = (e) => {
        setPreferred(e.target.value)
    }
    const handleIncreaseAdults = (e) => {
        e.stopPropagation();
        setAdults(parseFloat(adults + 1))
    }
    const handleDecreaseAdults = (e) => {
        e.stopPropagation();
        if (adults !== 1) {
            setAdults(parseFloat(adults - 1))
        }
    }
    const handleIncreaseKids = (e) => {
        e.stopPropagation();
        setKids(parseFloat(kids + 1))
    }
    const handleDecreaseKids = (e) => {
        e.stopPropagation();
        if (kids !== 0) {
            setKids(parseFloat(kids - 1))
        }
    }
    const handleIncreaseInfants = (e) => {
        e.stopPropagation();
        setInfants(parseFloat(infants + 1))
    }
    const handleDecreaseInfants = (e) => {
        e.stopPropagation();
        if (infants !== 0) {
            setInfants(parseFloat(infants - 1))
        }
    }
    const handleDepartureDate = (date) => {
        const selectedDate = date[0];
        setDepartureDate(selectedDate);

        // If returnDate is before the new departureDate, reset it to departureDate
        if (returnDate && selectedDate && returnDate < selectedDate) {
            setReturnDate(selectedDate);
        }
    };
    const handleReturnDate = (date) => {
        setReturnDate(date[0]);
    };
    const handleJourneyType = (e, type) => {
        e.preventDefault();
        setJourneyType(type)
    }
    function GetFlightDestinations() {
        const fvalues = [];
        for (var i = 0; i < trips.length; i++) {
            fvalues.push({ from: locationFrom, to: locationTo, departureDate: moment(departureDate).format('YYYY-MM-DD'), returnDate: moment(returnDate).format('YYYY-MM-DD') });
        }
        return fvalues;
    }
    const handleSearch = (e) => {
        e.preventDefault();
        if (validate()) {
            const searchQuery = {
                "journeyType": journeyType,
                "isDomestic": isDomestic,
                "adults": adults,
                "kids": kids,
                "infants": infants,
                "cabinClass": cabinClass,
                "companyId": DefaultData.DEFAULTCOMPANYID,
                "preferred": preffered,
                "isDirectFlight": isDirect,
                "isConnectingFlight": isConnecting,
                "flightTravelerPoints": GetFlightDestinations(),
            }
            console.log(searchQuery);
            navigate('/flight/' + adults + "/" + kids + "/" + infants + "/" + isDomestic, { state: { searchQuery } });
        }
    }
     const searchButtonStyle = {
        backgroundColor: DefaultData?.THEMECOLOR1, // Use theme color, fallback to default purple
        borderColor: DefaultData?.THEMECOLOR1, // Also set border color for consistency
    };
    const panelContainerStyle = {
        '--active-tab-color': DefaultData?.THEMECOLOR1,
         '--form-check-active-color': landingData?.themeColor1 || DefaultData?.THEMECOLOR1
    };

    return (
    <div className="search-flight-panel-container" style={panelContainerStyle}>
        <div className="card-body p-0">
            <div className="row">
                <div className="col-12">
                   <ul className="nav nav-pills arrow-navtabs nav-success mb-3" role="tablist">
                        <li className="nav-item me-2" role="presentation">
                            <Link className={journeyType === "ONEWAY" ? "nav-link active" : "nav-link bg-light"} name="ONEWAY" onClick={(e) => handleJourneyType(e, "ONEWAY")} to="#">
                                ONEWAY
                            </Link>
                        </li>
                        <li className="nav-item me-2" role="presentation">
                            <Link className={journeyType === "RETURN" ? "nav-link active" : "nav-link bg-light"} name="RETURN" onClick={(e) => handleJourneyType(e, "RETURN")} to="#">
                                ROUNDTRIP
                            </Link>
                        </li>
                    </ul>
                    </div>
                </div>
                <div className="flight-search-fields">
                    <div className="flight-search-field flight-location-field">
                        <label htmlFor="fromInput" className="form-label"><i className="ri-flight-takeoff-line" /> From</label>
                        <div className="flight-airport-autocomplete">
                            <input
                                ref={inputDRef}
                                id="fromInput"
                                className="form-control"
                                type="text"
                                placeholder="City or airport"
                                value={displayFrom}
                                autoComplete="off"
                                role="combobox"
                                aria-autocomplete="list"
                                aria-expanded={departureSuggestionsOpen}
                                onChange={handleDepartureAirportSearch}
                                onClick={handleDepartureAirportClick}
                                onFocus={handleDepartureAirportClick}
                                onKeyDown={(e) => {
                                    if (e.key === "Escape") setDepartureSuggestionsOpen(false);
                                }}
                            />
                            {departureSuggestionsOpen && (
                                <ul className="flight-airport-suggestions" role="listbox" aria-label="Departure airports">
                                    {airportListLoading ? (
                                        <li className="flight-airport-message">Loading airports...</li>
                                    ) : airportListError ? (
                                        <li className="flight-airport-message flight-airport-error">{airportListError}</li>
                                    ) : departureResults.length ? departureResults.map((airport) => (
                                        <li key={`${airport.airportCode}-${airport.cityName}`} role="option" aria-selected="false">
                                            <button type="button" className="flight-airport-option" onMouseDown={(e) => e.preventDefault()} onClick={() => handleDepartureSelect(airport)}>
                                                <span className="flight-airport-option-icon"><i className="ri-map-pin-line" aria-hidden="true" /></span>
                                                <span className="flight-airport-option-copy">
                                                    <span className="flight-airport-option-title">{airport.cityName}</span>
                                                    <span className="flight-airport-option-subtitle">{airport.airportName} · {airport.countryName}</span>
                                                </span>
                                                <span className="flight-airport-option-code">{airport.airportCode}</span>
                                            </button>
                                        </li>
                                    )) : (
                                        <li className="flight-airport-message">{displayFrom ? "No matching airports found" : "Popular airports"}</li>
                                    )}
                                </ul>
                            )}
                        </div>
                        {errors.from === false && (<div className="validationerror">Please select departure</div>)}
                    </div>
                    <div className="flight-search-field flight-location-field">
                        <label htmlFor="toInput" className="form-label"><i className="ri-flight-land-line" /> To</label>
                        <div className="flight-airport-autocomplete">
                            <input
                                ref={inputARef}
                                id="toInput"
                                className="form-control searchTextbox"
                                type="text"
                                placeholder="City or airport"
                                value={displayTo}
                                autoComplete="off"
                                role="combobox"
                                aria-autocomplete="list"
                                aria-expanded={arrivalSuggestionsOpen}
                                onChange={handleArrivalAirportSearch}
                                onClick={handleArrivalAirportClick}
                                onFocus={handleArrivalAirportClick}
                                onKeyDown={(e) => {
                                    if (e.key === "Escape") setArrivalSuggestionsOpen(false);
                                }}
                            />
                            {arrivalSuggestionsOpen && (
                                <ul className="flight-airport-suggestions" role="listbox" aria-label="Arrival airports">
                                    {airportListLoading ? (
                                        <li className="flight-airport-message">Loading airports...</li>
                                    ) : airportListError ? (
                                        <li className="flight-airport-message flight-airport-error">{airportListError}</li>
                                    ) : arrivalResults.length ? arrivalResults.map((airport) => (
                                        <li key={`${airport.airportCode}-${airport.cityName}`} role="option" aria-selected="false">
                                            <button type="button" className="flight-airport-option" onMouseDown={(e) => e.preventDefault()} onClick={() => handleArrivalSelect(airport)}>
                                                <span className="flight-airport-option-icon"><i className="ri-map-pin-line" aria-hidden="true" /></span>
                                                <span className="flight-airport-option-copy">
                                                    <span className="flight-airport-option-title">{airport.cityName}</span>
                                                    <span className="flight-airport-option-subtitle">{airport.airportName} · {airport.countryName}</span>
                                                </span>
                                                <span className="flight-airport-option-code">{airport.airportCode}</span>
                                            </button>
                                        </li>
                                    )) : (
                                        <li className="flight-airport-message">{displayTo ? "No matching airports found" : "Popular airports"}</li>
                                    )}
                                </ul>
                            )}
                        </div>
                    </div>
                    <div className="flight-search-field flight-date-field">
                        <label htmlFor="departureDate" className="form-label"><i className="ri-calendar-2-line" /> Depart</label>
                        <div className="input-group">
                            <Flatpickr
                                id="departureDate"
                                value={departureDate}
                                onChange={handleDepartureDate}
                                options={{ dateFormat: "d M Y", minDate: "today" }}
                                className="form-control"
                                placeholder="Choose date"
                            />
                        </div>
                    </div>
                    <div className={`flight-search-field flight-date-field${journeyType === "ONEWAY" ? " flight-return-placeholder" : ""}`}>
                        <label htmlFor="returnDate" className="form-label"><i className="ri-calendar-check-line" /> Return</label>
                        {journeyType === "RETURN" ? (
                            <div className="input-group">
                                <Flatpickr
                                    id="returnDate"
                                    value={returnDate}
                                    onChange={handleReturnDate}
                                    options={{ dateFormat: "d M Y", minDate: departureDate }}
                                    className="form-control"
                                    placeholder="Choose date"
                                />
                            </div>
                        ) : (
                            <button type="button" className="flight-return-button" onClick={() => setJourneyType("RETURN")}>
                                <strong>Add return date</strong>
                                <span>Save on round trips</span>
                            </button>
                        )}
                    </div>
                    <div className="flight-search-field flight-travellers-field">
                        <label htmlFor="travellersInput" className="form-label"><i className="ri-user-line" /> Travellers</label>
                        <div className="dropdown" data-bs-auto-close="outside">
                            <button className="form-control w-100 dropdown-toggle flight-travellers-toggle" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false">
                                <strong>{`${adults + kids + infants} Traveller${adults + kids + infants === 1 ? "" : "s"}`}</strong>
                                <span>{cabinClass.replace("_", " ")}</span>
                            </button>
                            <div className="dropdown-menu p-3" aria-labelledby="dropdownMenuButton" style={{width: '300px'}}>
                                <div className="mb-3 d-flex justify-content-between align-items-center">
                                    <span>Adults</span>
                                    <div className="input-step d-flex align-items-center">
                                        <button type="button" className="minus" onClick={handleDecreaseAdults}>–</button>
                                        <input type="number" className="product-quantity text-center" min="1" max="9" readOnly value={adults} name="adults" />
                                        <button type="button" className="plus" onClick={handleIncreaseAdults}>+</button>
                                    </div>
                                </div>
                                <div className="mb-3 d-flex justify-content-between align-items-center">
                                    <span>Kids</span>
                                    <div className="input-step d-flex align-items-center">
                                        <button type="button" className="minus" onClick={handleDecreaseKids}>–</button>
                                        <input type="number" className="product-quantity text-center" min="0" max="9" readOnly value={kids} name="kids" />
                                        <button type="button" className="plus" onClick={handleIncreaseKids}>+</button>
                                    </div>
                                </div>
                                <div className="mb-3 d-flex justify-content-between align-items-center">
                                    <span>Infants</span>
                                    <div className="input-step d-flex align-items-center">
                                        <button type="button" className="minus" onClick={handleDecreaseInfants}>–</button>
                                        <input type="number" className="product-quantity text-center" min="0" max="5" readOnly value={infants} name="infants" />
                                        <button type="button" className="plus" onClick={handleIncreaseInfants}>+</button>
                                    </div>
                                </div>
                                <div className="mb-3">
                                    <select className="form-select" value={cabinClass} onChange={handleClassType}>
                                        <option value="ECONOMY">ECONOMY</option>
                                        <option value="PREMIUM_ECONOMY">PREMIUM ECONOMY</option>
                                        <option value="BUSINESS">BUSINESS</option>
                                        <option value="FIRST">FIRST</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="flight-search-options">
                    <div className="flight-fare-options">
                        <span className="flight-fare-label">Fare type</span>
                        <div className="form-check form-check-inline">
                            <input className="form-check-input" type="radio" name="preffered" id="REGULAR" onChange={handlePrefferedType} value="REGULAR" checked={preffered === "REGULAR"} />
                            <label className="form-check-label" htmlFor="REGULAR">Regular</label>
                        </div>
                        <div className="form-check form-check-inline">
                            <input className="form-check-input" type="radio" name="preffered" id="STUDENT" onChange={handlePrefferedType} value="STUDENT" checked={preffered === "STUDENT"} />
                            <label className="form-check-label" htmlFor="STUDENT">Student</label>
                        </div>
                        <div className="form-check form-check-inline">
                            <input className="form-check-input" type="radio" name="preffered" id="CORPORATE" onChange={handlePrefferedType} value="CORPORATE" checked={preffered === "CORPORATE"} />
                            <label className="form-check-label" htmlFor="CORPORATE">Corporate</label>
                        </div>
                        <div className="form-check form-check-inline">
                            <input className="form-check-input" type="radio" name="preffered" id="SENIOR_CITIZEN" onChange={handlePrefferedType} value="SENIOR_CITIZEN" checked={preffered === "SENIOR_CITIZEN"} />
                            <label className="form-check-label" htmlFor="SENIOR_CITIZEN">Senior citizen</label>
                        </div>
                        <div className="form-check form-check-inline">
                            <input className="form-check-input" type="checkbox" name="isDirect" id="isDirect" onChange={handleDirectType} checked={isDirect} />
                            <label className="form-check-label" htmlFor="isDirect">Non-stop</label>
                        </div>
                        <div className="form-check form-check-inline">
                            <input className="form-check-input" type="checkbox" name="isConnecting" id="isConnecting" onChange={handleConnectingType} checked={isConnecting} />
                            <label className="form-check-label" htmlFor="isConnecting">Connecting flight</label>
                        </div>
                    </div>
                    <button type="button" onClick={handleSearch} className="btn btn-search flight-search-submit" style={searchButtonStyle}>
                        <i className="ri-search-line" aria-hidden="true" /> Search Flights
                    </button>
                </div>
            </div>
        </div>
    );
};

export default FlightSearchPanel;